type LogDetail = unknown;

const productionLoggingEnabled = (): boolean => {
  const value = import.meta.env.VITE_ENABLE_LOGGING;
  return value === 'true' || value === '1';
};

const shouldLog = (): boolean => import.meta.env.DEV || productionLoggingEnabled();

const formatArgs = (message: string, detail?: LogDetail): [string] | [string, LogDetail] => {
  if (detail === undefined) {
    return [message];
  }

  return [message, detail];
};

export const logger = {
  error(message: string, detail?: LogDetail): void {
    if (!shouldLog()) {
      return;
    }

    console.error(...formatArgs(message, detail));
  },
};
